import LOGO_DARK_BACKGROUND from '../logo_dark_background.png';
import LOGO_LIGHT_BACKGROUND from '../logo_light_background.png';
export const IMAGES = {
	LOGO_DARK_BACKGROUND: LOGO_DARK_BACKGROUND,
	LOGO_LIGHT_BACKGROUND: LOGO_LIGHT_BACKGROUND,
	FILE_NOT_AVAILABLE: 'https://storage.googleapis.com/tirx-resources-develop/e53ff4f8-36d9-4856-980e-2464022aa6e7.webp',
};
